import { Table, Tag, Space, Button } from "antd";

import CheckIcon from "@/icons/CheckIcon";
import PencilIcon from "@/icons/PencilIcon";
import TrashIcon from "@/icons/TrashIcon";

import { PRIORITY_OPTIONS } from "@/constants/tasks";

const disableDelete = (item) => {
  if (!item) return true;
  if (
    item.is_default ||
    (item.deleted && !item.can_be_deleted) ||
    (!item.can_be_deleted && !item.can_be_marked_deleted)
  )
    return true;
  return false;
};

// Таблица приоритетов
// Содержит список с возможностью сортировки
// Тут можно настроить колонки
const PrioritiesTable = ({
  data,
  loading,
  pagination,
  onChange,
  onEditItem,
  onDeleteItem,
  scroll = { x: "100%" },
}) => {
  const getIcon = (color) => {
    return PRIORITY_OPTIONS.find((item) => item.value === color)?.icon;
  };

  const columns = [
    {
      title: "№ п/п",
      dataIndex: "idx",
      key: "idx",
      width: 90,
      defaultSortOrder: "ascend",
      sorter: {
        compare: (a, b) => a.idx - b.idx,
        multiple: 1,
      },
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 2,
      },
      render: (_, { name, color }) => (
        <Tag icon={getIcon(color)} className="tag-with-icon">
          {name}
        </Tag>
      ),
    },
    {
      title: "Удален",
      dataIndex: "deleted",
      key: "deleted",
      align: "center",
      render: (deleted) =>
        deleted ? <CheckIcon style={{ fontSize: 16 }} /> : "",
    },
    {
      title: "",
      width: 90,
      fixed: "right",
      align: "center",
      key: "actions",
      render: (_, item) => (
        <Space>
          <Button
            type="link"
            icon={<PencilIcon />}
            onClick={() => onEditItem(item)}
          ></Button>
          <Button
            type="link"
            icon={<TrashIcon />}
            disabled={disableDelete(item)}
            onClick={() => onDeleteItem(item)}
          ></Button>
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
    />
  );
};

export default PrioritiesTable;
